import React from 'react';
import { Plane, MapPin } from 'lucide-react';
import { Card } from './ui/card';

const AerialPackages = ({ onOpenForm }) => {
  const destinations = [
    {
      name: 'Rio de Janeiro',
      description: 'Cristo Redentor e praias paradisíacas',
      image: 'https://images.unsplash.com/photo-1593091399348-b66b3c0868cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxDcmlzdG8lMjBSZWRlbnRvciUyMFJpbyUyMEphbmVpcm98ZW58MHx8fHwxNzcwMzMwOTcxfDA&ixlib=rb-4.1.0&q=85'
    },
    {
      name: 'Porto de Galinhas',
      description: 'Piscinas naturais e águas cristalinas',
      image: 'https://images.unsplash.com/photo-1698760043699-286349868fa8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxQb3J0byUyMGRlJTIwR2FsaW5oYXN8ZW58MHx8fHwxNzcwMzMwOTc1fDA&ixlib=rb-4.1.0&q=85'
    },
    {
      name: 'João Pessoa',
      description: 'Praias tranquilas e natureza',
      image: 'https://images.unsplash.com/photo-1732217164523-d147e04babaf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxKbyVDMyVBM28lMjBQZXNzb2ElMjBiZWFjaHxlbnwwfHx8fDE3NzAzMzA5ODB8MA&ixlib=rb-4.1.0&q=85'
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 bg-cyan-100 text-cyan-700 px-4 py-2 rounded-full mb-3">
            <Plane className="w-4 h-4" />
            <span className="font-semibold text-sm">Outros Destinos</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            Pacotes <span className="text-red-600">Aéreos</span>
          </h2>
          <p className="text-lg text-gray-600 mb-4">
            Explore outros destinos brasileiros incríveis
          </p>
        </div>

        {/* Destinations Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {destinations.map((destination, index) => (
            <Card 
              key={index}
              className="overflow-hidden border-none shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group cursor-pointer"
              onClick={onOpenForm}
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={destination.image}
                  alt={destination.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5 text-white">
                  <div className="flex items-center gap-2 mb-2">
                    <MapPin className="w-4 h-4 text-cyan-400" />
                    <h3 className="text-xl font-bold">{destination.name}</h3>
                  </div>
                  <p className="text-gray-200 text-sm">{destination.description}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* CTA */}
        <div className="bg-gradient-to-r from-cyan-600 to-blue-600 rounded-2xl p-8 text-white text-center shadow-xl">
          <h3 className="text-2xl font-bold mb-3">
            Consulte Outros Destinos
          </h3>
          <p className="text-lg mb-6 text-white/90">
            Temos pacotes para diversos destinos brasileiros
          </p>
          <button
            onClick={onOpenForm}
            className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-8 rounded-full text-lg transition-all duration-300 hover:scale-105 shadow-lg animate-pulse-glow"
          >
            Solicitar Orçamento
          </button>
        </div>
      </div>
    </section>
  );
};

export default AerialPackages;
